module.exports = __webpack_public_path__ + "img/menu-diancloud.2bc0614a.svg";